// extracted by mini-css-extract-plugin
export var actions = "_d-4";
export var brand = "_d-3";
export var header = "_d-0";
export var headerContent = "_d-1";
export var identity = "_d-5";
export var logo = "_d-2";